module.exports = __webpack_public_path__ + "static/media/HOME.403d7c15.mp4";